/**
 * Promo-Geschenk wird IM GLEICHEN /cart/add Request mitgeschickt.
 * => Drawer/Cart sieht das Geschenk sofort beim ersten Add.
 * Keine App nötig. Funktioniert mit fetch, XHR, Form-Submit, JSON & FormData.
 */
(function () {
  // ==== CONFIG ====
  const GIFT_VARIANT_ID = 50030627750234; // <-- DEINE Geschenk-Variant-ID
  const PROMO_PARAM     = 'giftpromo';
  const PROMO_VALUE     = 'kdh';      // <-- z.B. ?giftpromo=kdh
  const TTL_HOURS       = 24;
  const GIFT_PROP_KEY   = '_gift';
  const GIFT_PROP_VAL   = 'Promo';

  // ==== Promo-Flag (Session) ====
  const KEY='promo_gift_active';
  const now=()=>Date.now();
  function setActive(){ try{sessionStorage.setItem(KEY,JSON.stringify({a:1,exp:now()+TTL_HOURS*3600e3}))}catch{} }
  function active(){ try{const d=JSON.parse(sessionStorage.getItem(KEY)||''); return d&&d.a&&d.exp>now();}catch{return false} }
  try{
    const v=new URLSearchParams(location.search).get(PROMO_PARAM);
    if(v===PROMO_VALUE) setActive();
    if(v==='off') sessionStorage.removeItem(KEY);
  }catch{}

  // ==== Helpers ====
  const sleep=ms=>new Promise(r=>setTimeout(r,ms));
  async function getCart(){ const r=await fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}); return r.json(); }
  function cartHasGift(c){ return (c.items||[]).some(it=>it.variant_id===GIFT_VARIANT_ID || (it.properties && it.properties[GIFT_PROP_KEY]===GIFT_PROP_VAL)); }
  function payloadHasGift(payload){
    // prüft, ob im Add-Payload bereits das Geschenk steckt
    if (!payload) return false;
    if (payload.items && Array.isArray(payload.items)) return payload.items.some(i=>+i.id===GIFT_VARIANT_ID);
    // urlencoded: items[0][id]=... etc. -> prüfen im encode-Schritt
    return false;
  }

// --- Gift-Removal Helpers ---
async function removeGift() {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type':'application/json','Accept':'application/json' },
    credentials: 'same-origin',
    cache: 'no-store',
    body: JSON.stringify({ updates: { [GIFT_VARIANT_ID]: 0 } })
  });
  if (typeof forceRefreshCartDrawer === 'function') {
    await forceRefreshCartDrawer();
  }
}

// Entfernt das Geschenk, wenn keine Nicht-Geschenk-Artikel mehr im Cart sind
async function enforceGiftQualification() {
  try {
    const c = await fetch('/cart.js', { credentials:'same-origin', cache:'no-store' }).then(r=>r.json());
    const hasNonGift = (c.items||[]).some(it => it.variant_id !== GIFT_VARIANT_ID);
    const hasGift    = (c.items||[]).some(it => it.variant_id === GIFT_VARIANT_ID);
    if (!hasNonGift && hasGift) {
      await removeGift();
    }
  } catch(e) { /* noop */ }
}



  // ==== Kern: Request erweitern ====
  async function maybeAugmentAdd(input, init, viaXHR){
    // schon vorab prüfen, ob Promo überhaupt aktiv
    if (!active()) return {input, init};

    // Prüfen, ob Geschenk schon im Warenkorb ist
    let c;
    try { c = await getCart(); } catch {}
    if (c && cartHasGift(c)) return {input, init}; // nichts tun

    // Wir augmentieren nur, wenn in DIESEM Add auch ein Nicht-Geschenk enthalten ist
    // -> dazu müssen wir den Body lesen & ggf. umbauen
    const isJSON = init && init.headers && (
      (init.headers.get && (init.headers.get('Content-Type')||'').includes('application/json')) ||
      (typeof init.headers === 'object' && (String(init.headers['Content-Type']||init.headers['content-type']||'').includes('application/json')))
    );

    // 1) JSON-Body
    if (isJSON && init && init.body) {
      try {
        const data = JSON.parse(init.body);
        // wenn items fehlen, nicht augmentieren
        if (!data || !Array.isArray(data.items) || data.items.length===0) return {input, init};
        // wenn payload bereits Geschenk enthält: nichts tun
        if (payloadHasGift(data)) return {input, init};
        // check: enthält mindestens EIN Nicht-Geschenk?
        const hasNonGift = data.items.some(i => +i.id !== GIFT_VARIANT_ID);
        if (!hasNonGift) return {input, init};

        // Geschenk anhängen
        data.items.push({ id: GIFT_VARIANT_ID, quantity: 1, properties: { [GIFT_PROP_KEY]: GIFT_PROP_VAL } });

        return { input, init: { ...init, body: JSON.stringify(data), cache:'no-store' } };
      } catch { return {input, init}; }
    }

    // 2) FormData (häufigster Fall bei Themes)
    if (init && init.body && (init.body instanceof FormData)) {
      const fd = init.body;

      // Erkennen, ob schon ein Nicht-Geschenk drin ist
      let hasNonGift=false, alreadyGift=false, itemsCount=0;
      for (const [k,v] of fd.entries()) {
        if (/items\[\d+\]\[id\]/.test(k)) {
          itemsCount++;
          const idNum = +String(v||'');
          if (idNum === GIFT_VARIANT_ID) alreadyGift = true;
          else hasNonGift = true;
        }
        // Single-add (ohne items[0]) via 'id='
        if (k==='id') {
          const idNum=+String(v||'');
          if (idNum === GIFT_VARIANT_ID) alreadyGift = true;
          else hasNonGift = true;
        }
      }
      if (alreadyGift || !hasNonGift) return {input, init};

      // Geschenk anhängen (index berechnen)
      const idx = itemsCount>0 ? itemsCount : (fd.has('id') ? 1 : 0);

      // Wenn es ein 'id' Feld gibt (Single add), konvertieren wir elegant zu multi-items (Shopify akzeptiert beide parallel)
      // -> wir fügen einfach zusätzlich items[idx][id] usw. hinzu
      fd.append(`items[${idx}][id]`, String(GIFT_VARIANT_ID));
      fd.append(`items[${idx}][quantity]`, '1');
      fd.append(`items[${idx}][properties][${GIFT_PROP_KEY}]`, GIFT_PROP_VAL);

      return { input, init: { ...init, body: fd, cache:'no-store' } };
    }

    // 3) URL-encoded (application/x-www-form-urlencoded) – seltener
    if (init && typeof init.body === 'string' && (!isJSON)) {
      const s = init.body;
      // Parsen
      const params = new URLSearchParams(s);
      let hasNonGift=false, alreadyGift=false, itemsCount=0;

      // Single add?
      if (params.has('id')) {
        const idNum=+params.get('id');
        if (idNum === GIFT_VARIANT_ID) alreadyGift = true; else hasNonGift = true;
      }

      // Multi add?
      for (const [k,v] of params.entries()) {
        if (/items\[\d+\]\[id\]/.test(k)) {
          itemsCount++;
          const idNum=+v;
          if (idNum === GIFT_VARIANT_ID) alreadyGift = true; else hasNonGift = true;
        }
      }
      if (alreadyGift || !hasNonGift) return {input, init};

      const idx = itemsCount>0 ? itemsCount : (params.has('id') ? 1 : 0);
      params.append(`items[${idx}][id]`, String(GIFT_VARIANT_ID));
      params.append(`items[${idx}][quantity]`, '1');
      params.append(`items[${idx}][properties][${GIFT_PROP_KEY}]`, GIFT_PROP_VAL);

      return { input, init: { ...init, body: params.toString(), cache:'no-store' } };
    }

    // 4) Kein auswertbarer Body -> als Fallback nichts ändern
    return {input, init};
  }

  // ==== fetch patch ====
  const _fetch = window.fetch;
  window.fetch = async function (input, init = {}) {
    const url = typeof input==='string' ? input : (input && input.url) || '';
    const isAdd = url.includes('/cart/add');
    if (!isAdd) return _fetch(input, init);

    const mod = await maybeAugmentAdd(input, init, false);
    return _fetch(mod.input, mod.init);
  };

  // ==== XHR patch ====
  (function(){
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, async, user, pass){
      this.__isAdd = (typeof url==='string' && url.indexOf('/cart/add')>-1 && String(method).toUpperCase()==='POST');
      return _open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(body){
      if (!this.__isAdd) return _send.apply(this, arguments);

      // Wir können XHR-Body nicht direkt ersetzen, daher: auf fetch umleiten & Response in dieses XHR spiegeln
      // -> funktioniert zuverlässig & sorgt dafür, dass Theme den kombinierten Add bekommt
      const xhr = this;

      (async () => {
        const url = xhr.responseURL || (xhr.__url || '/cart/add');
        let init = { method:'POST', credentials:'same-origin' };

        // Content-Type heuristisch
        const ct = xhr.getRequestHeader ? xhr.getRequestHeader('Content-Type') : '';
        if (body instanceof FormData) {
          init.body = body;
        } else if (typeof body === 'string' && ct && ct.includes('application/json')) {
          init.headers = {'Content-Type':'application/json','Accept':'application/json'};
          init.body = body;
        } else if (typeof body === 'string') {
          init.headers = {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8','Accept':'application/json'};
          init.body = body;
        } else {
          init.body = body || null;
        }

        const mod = await maybeAugmentAdd(url, init, true);
        const res = await fetch(url, mod.init);
        const text = await res.text();

        // Fake die XHR-Events, damit Theme-Callbacks weiterlaufen
        Object.defineProperty(xhr, 'readyState', { value: 4, writable: false });
        Object.defineProperty(xhr, 'status', { value: res.status, writable: false });
        Object.defineProperty(xhr, 'response', { value: text, writable: false });
        Object.defineProperty(xhr, 'responseText', { value: text, writable: false });

        if (xhr.onreadystatechange) xhr.onreadystatechange();
        xhr.dispatchEvent(new Event('readystatechange'));
        xhr.dispatchEvent(new Event('load'));
        xhr.dispatchEvent(new Event('loadend'));
      })();

      // Sende nichts weiter – wir übernehmen komplett
      // return _send.apply(this, arguments); // absichtlich NICHT aufrufen
    };
  })();

  // (Optional) Wenn Kunde bereits mit vollem Warenkorb über Promo-Link kommt,
  // beim Laden prüfen und ggf. Geschenk in EINEM Schritt hinzufügen.
  document.addEventListener('DOMContentLoaded', async () => {
    if (!active()) return;
    try {
      const c = await getCart();
      if (!c.items || !c.items.length) return;
      if (cartHasGift(c)) return;

      // Multi-add in EINEM Request via /cart/add.js
      const body = {
        items: [
          // nichts aus Cart entfernen – wir fügen nur das Geschenk zusätzlich hinzu
          { id: GIFT_VARIANT_ID, quantity: 1, properties: { [GIFT_PROP_KEY]: GIFT_PROP_VAL } }
        ],
        sections_url: location.pathname
      };
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json','Accept':'application/json' },
        credentials: 'same-origin',
        cache:'no-store',
        body: JSON.stringify(body)
      });
    } catch {}
  });


  
  
})();
